import {httpClient} from "./index";
import axios from "axios";
import Cookies from "js-cookie";

class AuthService {

    constructor(httpClient) {
        this.httpClient = httpClient;
    }


async login(body) {
    return await axios.post(`https://attractions-tickets.fun/auth/login`, body);
}

async findUserByToken() {
    return await this.httpClient.get(`https://attractions-tickets.fun/auth/findByToken`);
}



}

export default AuthService;
